import { FC, HTMLAttributes, ReactNode } from 'react';

export interface ITableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  children?: ReactNode;
}

export const TableRow: FC<ITableRowProps> = ({ children, className, ...props }) => (
  <tr className={className} {...props}>
    {children}
  </tr>
);
